import { Action, combineReducers } from '@ngrx/store';

import * as PostProject from './postProject/reducer';
import * as PostComeroundProject from './postComeroundProject/reducer';
import * as GetProjectById from './getProjectById/reducer';
import * as PutProject from './putProject/reducer';
import * as GetCoverages from './getCoverages/reducer';
import * as PutCoverages from './putCoverages/reducer';
import * as Simulation from './simulation/reducer';

export const featureKey = 'project';

export interface ProjectState {
  [PostProject.featureKey]: PostProject.State;
  [PostComeroundProject.featureKey]: PostComeroundProject.State;
  [PutProject.featureKey]: PutProject.State;
  [GetProjectById.featureKey]: GetProjectById.State;
  [GetCoverages.featureKey]: GetCoverages.State;
  [PutCoverages.featureKey]: PutCoverages.State;
  [Simulation.featureKey]: Simulation.State;
}

export interface State {
  [featureKey]: ProjectState;
}

export const reducers = {
  [PostProject.featureKey]: PostProject.reducer,
  [PostComeroundProject.featureKey]: PostComeroundProject.reducer,
  [PutProject.featureKey]: PutProject.reducer,
  [GetProjectById.featureKey]: GetProjectById.reducer,
  [GetCoverages.featureKey]: GetCoverages.reducer,
  [PutCoverages.featureKey]: PutCoverages.reducer,
  [Simulation.featureKey]: Simulation.reducer,
};

export function combiner(state: ProjectState | undefined, action: Action) {
  return combineReducers(reducers)(state, action);
}
